// src/pages/FriendDetail.jsx
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer';

const friends = [
  {
    id: 1,
    title: "John Doe",
    description: "Full description for John Doe. John is the CEO and has over 20 years of experience in the software industry.",
    content: "This is the detailed content about John Doe.",
    imgSrc: "https://via.placeholder.com/150"
  },
  {
    id: 2,
    title: "Jane Smith",
    description: "Full description for Jane Smith. Jane is the CTO with a passion for technology and innovation.",
    content: "This is the detailed content about Jane Smith.",
    imgSrc: "https://via.placeholder.com/150"
  },
  {
    id: 3,
    title: "Sam Johnson",
    description: "Full description for Sam Johnson. Sam is the CFO and oversees the financial operations of the company.",
    content: "This is the detailed content about Sam Johnson.",
    imgSrc: "https://via.placeholder.com/150"
  }
];

const FriendDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const friend = friends.find(friend => friend.id === parseInt(id));

  if (!friend) {
    return (
      <>
        <NavBar />
        <div className="container mx-auto my-12 px-4">
          <h1 className="text-4xl font-bold text-blue-900 text-center mb-12">Friend not found</h1>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div>
        <NavBar />
      </div>
      <div className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
        <div className="container mx-auto my-8 px-4 lg:px-20">
          <h1 className="text-4xl font-bold text-blue-900 text-center mb-12">{friend.title}</h1>
          <img src={friend.imgSrc} alt={friend.title} className="w-full h-48 object-cover mb-8" />
          <p className="text-gray-600 mt-4">{friend.description}</p>
          <div className="mt-8">
            <p>{friend.content}</p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center px-6 py-3 mt-8 text-lg shadow-xl rounded-xl"
            aria-label="Go back to the previous page"
          >
            Back
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FriendDetail;
